<!-- The result card, per the approved G0 drawing:
     https://claude.ai/code/artifact/769bae85-574d-4ec4-b72e-33d3e9147479 (rulings L79-L84).
     The URL follows the drawing across republishes; the rulings carry the substance in words. No
     revision number is cited here on purpose - a pinned one rots and still reads as precision.

     Row 1   rank · date (weekday, dd-MMM-yy, backend DTE) · A H marks .......... LEDGER price
     Row 2   Score: 98 of 100 ................................................... cost per day
             a rule
     Then    Adjustment / Hedges / a closing rule                       (Existing Hedges = Ignore)
             Adjustment / New hedges / Closing hedges / a closing rule  (Existing Hedges = Close)

     Cost per day sits under the price (owner, vrequest 2026-09-13, Results items 3-4 — REPLACES
     the drawing's row 2 and ruling D2, which kept the per-day figure in the Details column). The
     second pass that day REMOVED both Total rows and closed the breakdown with the score: the
     headline price is the one total. Every money figure on the card is coloured by its sign:
     credit green, debit red, and a dash stays grey.

     A not-ready card shows the date and says so. It carries no rank, no figures and no marks —
     nothing unknown is ever drawn as zero. -->

<div class="mv-card"
     data-element="maven-card"
     [class.not-ready]="this.isNotReady"
     [class.selected]="this.selected"
     [class.locked]="this.lockedByAnotherCard"
     (click)="this.onPick()">

  <!-- ONE header line (owner sketch, sixth pass 2026-09-13 — REPLACES the two-row grid and the
       fraction): rank, date, the A H marks right after the date, the price at the right edge. -->
  <div class="r1">
    <span class="rank" data-element="card-rank">{{ this.rankText }}</span>
    <span class="date" data-element="card-date">{{ this.dateText }}</span>
    <!-- Each mark is split by a diagonal (owner sketch, vrequest 2026-09-15, CR-20260915-003):
         the top-left half is Calls, the bottom-right half is Puts. A half lights green when that
         side was copied from THIS card; both lit = the whole chip. A single-side portfolio lights
         both halves on its one copy. -->
    <span class="marks" *ngIf="!this.isNotReady" data-element="card-marks">
      <span class="mk" data-element="mark-adjustment"
            [class.calls]="this.marks.adjustment.calls"
            [class.puts]="this.marks.adjustment.puts"
            [title]="this.markTitle('Adjustment', this.marks.adjustment)">A</span>
      <span class="mk" data-element="mark-hedges"
            [class.calls]="this.marks.hedges.calls"
            [class.puts]="this.marks.hedges.puts"
            [title]="this.markTitle('Hedges', this.marks.hedges)">H</span>
    </span>
    <span class="px"
          *ngIf="!this.isNotReady"
          data-element="card-ledger-price"
          [class.credit]="this.isCredit"
          [class.debit]="this.isDebit">{{ this.ledgerTotalText }}</span>
  </div>

  <div class="waitline" *ngIf="this.isNotReady" data-element="card-awaiting">awaiting price</div>

  <ng-container *ngIf="!this.isNotReady">

    <!-- The report on this card's own date. Names the report; never says the day came back. -->
    <div class="report" *ngIf="this.reportText" data-element="card-report">{{ this.reportText }}</div>

    <!-- The score line: "Score: N of 100" at the left, the cost per day at the right, one line at
         the breakdown's size (owner sketch, sixth pass). The number alone is bold. A rule closes it
         off from the Adjustment line below. -->
    <div class="scoreline" data-element="card-score-line">
      <span class="score-text">Score: <b data-element="card-score">{{ this.scoreText }}</b> of 100</span>
      <span class="perday"
            data-element="card-per-day"
            [ngClass]="this.signClass(this.perDay)">{{ this.perDayText }}</span>
    </div>

    <!-- The breakdown and a closing rule (owner, vrequest 2026-09-13, second pass): the Total rows
         are GONE — the headline price is the card's one total. Each rule is ONE element spanning
         both grid columns: drawn as two cell borders it broke at the column gap.

         Its shape follows the Existing Hedges choice the run was sent with (third pass, same day):
         Close splits the hedges into New hedges and Closing hedges; Ignore keeps one netted Hedges
         line. The choice decides, not the figure — a zero close-out still gets its line. -->
    <dl class="bd" data-element="card-breakdown">
      <!-- The adjustment TYPES ride the Adjustment label (owner, 2026-09-21): `2B(C) + 2B(P)`,
           the APG ORION's delivered strings, the same text the Summary's Pros shows. -->
      <dt>Adjustment<span class="atype"
                          *ngIf="this.adjustmentTypesText"
                          data-element="breakdown-adjustment-types">{{ this.adjustmentTypesText }}</span></dt>
      <dd data-element="breakdown-adjustment" [ngClass]="this.signClass(this.adjustment)">{{ this.adjustmentText }}</dd>

      <ng-container *ngIf="this.showsClosingHedges; else nettedHedges">
        <dt>New hedges</dt>
        <dd data-element="breakdown-new-hedges" [ngClass]="this.signClass(this.newHedges)">{{ this.newHedgesText }}</dd>

        <dt>Closing hedges</dt>
        <dd data-element="breakdown-closing-hedges" [ngClass]="this.signClass(this.closingHedges)">{{ this.closingHedgesText }}</dd>
      </ng-container>

      <ng-template #nettedHedges>
        <dt>Hedges</dt>
        <dd data-element="breakdown-hedges" [ngClass]="this.signClass(this.hedgesLine)">{{ this.hedgesText }}</dd>
      </ng-template>

      <div class="hr" role="presentation"></div>
    </dl>

  </ng-container>

</div>
